// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2N9hq","icon":"styles_icon__2y8PD"};